import { UserRoleEnum } from 'enums'
import { Page404 } from 'pages'
import { useSelector } from 'react-redux'
import { selectUser, userSelectors } from 'slices/user.slice'
import { LoadingIndicator } from './LoadingIndicator'

export type ProtectedRouteProps = {
  role: UserRoleEnum | Array<UserRoleEnum>
  children: React.ReactElement
}

export function ProtectedRoute(props: ProtectedRouteProps) {
  const role = useSelector(userSelectors.selectRole)

  if ((Array.isArray(props.role) && props.role.includes(role)) || props.role === role) {
    return props.children
  }
  if (!role) {
    return <LoadingIndicator />
  }
  return <Page404 />
}
